const PurchaseRedSvg = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4036_53204)">
      <circle cx="20" cy="20" r="20" fill="#CE212B" fillOpacity="0.05" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9997 28.8359C19.7235 28.8359 19.4997 28.6121 19.4997 28.3359L19.4997 17.8764L17.0199 20.3562C16.8246 20.5514 16.508 20.5514 16.3128 20.3562C16.1175 20.1609 16.1175 19.8443 16.3128 19.649L19.6461 16.3157C19.8414 16.1205 20.158 16.1205 20.3532 16.3157L23.6866 19.6491C23.8818 19.8443 23.8818 20.1609 23.6866 20.3562C23.4913 20.5514 23.1747 20.5514 22.9795 20.3562L20.4997 17.8764L20.4997 28.3359C20.4997 28.6121 20.2758 28.8359 19.9997 28.8359ZM23.7335 27.4714C23.5953 27.2324 23.6769 26.9266 23.916 26.7883C26.2587 25.4331 27.833 22.9014 27.833 20.0026C27.833 15.6764 24.3259 12.1693 19.9997 12.1693C15.6734 12.1693 12.1663 15.6764 12.1663 20.0026C12.1663 22.9014 13.7407 25.4331 16.0834 26.7883C16.3224 26.9266 16.4041 27.2324 16.2658 27.4714C16.1275 27.7105 15.8217 27.7922 15.5826 27.6539C12.9437 26.1273 11.1663 23.2728 11.1663 20.0026C11.1663 15.1241 15.1212 11.1693 19.9997 11.1693C24.8782 11.1693 28.833 15.1241 28.833 20.0026C28.833 23.2728 27.0557 26.1273 24.4167 27.6539C24.1777 27.7922 23.8718 27.7105 23.7335 27.4714Z"
        fill="#CE212B"
      />
    </g>
    <defs>
      <clipPath id="clip0_4036_53204">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PurchaseRedSvg;
